





































import {Mixins, Prop} from "vue-property-decorator";
import Component from "vue-class-component";
import {Style, Widget, WidgetParameters} from "@/components/dashboard/Dashboard.vue";
import Container from "@/components/dashboard/widgets/Container.vue";
import _ from "lodash";
import DashboardMixin from "@/mixins/dashboard/DashboardMixin";

const components = {
    Container,
};

interface ContactLinkParameters extends WidgetParameters {
    imageUrl?: string;
    name?: string;
    job?: string;
    cta?: {
        label: string;
        url?: string;
        route?: string;
    };
}

interface ImageLinkData extends Widget {
    parameters: ContactLinkParameters;
}

@Component({components})

export default class ContactLink extends Mixins(DashboardMixin) {
    @Prop({default: null}) public widget !: ImageLinkData;

    protected get hasCta(): boolean {
        return _.get(this.widget.parameters, "cta", false) && (this.isUrlLink || this.isRouteLink);
    }

    protected get isUrlLink(): boolean {
        return _.get(this.widget.parameters, "cta.url", false);
    }

    protected get isRouteLink(): boolean {
        return _.get(this.widget.parameters, "cta.route", false);
    }

    protected get containerStyle(): Style {
        return {
            padding: 0,
        };
    }

    protected goToCta(): void {
        if (this.isUrlLink && this.widget?.parameters?.cta?.url) {
            window.open(this.widget.parameters.cta.url, "_blank");
        } else if (this.isRouteLink && this.widget?.parameters?.cta?.route) {
            this.$router.push(this.widget.parameters.cta.route);
        }
    }
}
